import { createContext } from "react";
import { ConfigurationsContextType } from "./ConfigurationsContextTypes";


export const ConfigurationsContext = createContext<ConfigurationsContextType | undefined>(undefined);
